import { PluginDetails } from "@/features/plugins/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/plugins/$pluginId")({
	component: PluginDetailsPage,
});

function PluginDetailsPage() {
	return <PluginDetails />;
}
